import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\talign-items: center;\n\tcolor: ", ";\n\tdisplay: flex;\n\tjustify-content: center;\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { styled, ui } from '@wp-g2/styles';
export var ArrowIndicatorView = styled.div(_templateObject(), ui.color.text);